import PropTypes from "prop-types";
import React from "react";
import { Card, Container } from "react-bootstrap";

export const PersonalityProfile = ({ puppy }) => {
  return (
    <div className="personality-profile">
      <Container>
        <div style={{ padding: "2rem 0" }}>
          <Card>
            <Card.Header>
              <h2>Personality & Temperament</h2>
              <p className="text-muted mb-0">
                Professional assessment of {puppy.cardHeaderTitle}
              </p>
            </Card.Header>
            <Card.Body>
              <div style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                {puppy.personality ? (
                  <p>{puppy.personality}</p>
                ) : (
                  <p>
                    {puppy.cardHeaderTitle} has been professionally trained and
                    assessed by our expert team. For detailed personality
                    information, please contact us directly.
                  </p>
                )}
              </div>

              {puppy.breed && (
                <div className="mt-4 pt-3 border-top">
                  <h5>Breed Information</h5>
                  <p>
                    <strong>Breed:</strong> {puppy.breed}
                  </p>
                  {puppy.breedLong && (
                    <p>
                      <strong>Full Description:</strong> {puppy.breedLong}
                    </p>
                  )}
                  {puppy.projectedSize && (
                    <p>
                      <strong>Projected Size:</strong> {puppy.projectedSize}
                    </p>
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

PersonalityProfile.propTypes = {
  puppy: PropTypes.object.isRequired,
};
